import Axios from 'axios'
import {bus} from './main'

export default () => {
  const token = localStorage.getItem('token')
  const instance = Axios.create({
    headers: {
      'Authorization': 'Bearer ' + token
    }
  })
  instance.interceptors.request.use(function (config) {
    if (config.method !== 'get') {
      bus.$emit('loading', true)
    }
    return config
  }, function (error) {
    return Promise.reject(error)
  })
  instance.interceptors.response.use(function (config) {
    bus.$emit('loading', false)
    return config
  }, function (error) {
    return Promise.reject(error)
  })
  return instance
}



// WEBPACK FOOTER //
// ./src/remote.js